import React from "react";
import cn from "classnames";

import { TooltipedEllipsis } from "../TooltipedEllipsis/TooltipedEllipsis";
import CustomImage from "../CustomImage/CustomImage";

import "./UsernameAndAvatar.scss";

interface UsernameAndAvatarProps {
  username?: string;
  avatarUrl: string;
  avatarClassName?: string;
  tooltipMaxWidth?: number;
}

export default function UsernameAndAvatar({
  username,
  avatarUrl,
  avatarClassName,
  tooltipMaxWidth,
}: UsernameAndAvatarProps) {
  return (
    <div className="username-and-avatar">
      <CustomImage
        src={avatarUrl}
        className={cn("username-and-avatar__avatar", avatarClassName)}
        alt="avatar"
      />
      <TooltipedEllipsis
        className="username-and-avatar__username"
        maxWidth={tooltipMaxWidth ?? 250}
        content={username}
      />
    </div>
  );
}
